import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_MORE_OF_WHAT_YOU_LOVE_SUGGESTIONS = apiPromiseTypes(
  'basket-builder-experience-suggestions-by-category',
  'get',
);

export const MORE_OF_WHAT_YOU_LOVE_OFFER_FILTER_IMPRESSION =
  'waitrose/more-of-what-you-love/MORE_OF_WHAT_YOU_LOVE_OFFER_FILTER_IMPRESSION';
